import {
  filterK8Grades,
  sortGradesWithKFirst,
  filterDwbGrades,
  sortDwbGradesWithKFirst,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  convertGradeToDisplayValue,
  convertGradeNameToLabel,
  getProgramName,
  getCoreCourseCodeFromGradeLabel,
  getDwbCourseCodeFromGradeLabel,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const courseFilterConfig = {
  filterFunction: filterK8Grades,
  sortFunction: sortGradesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, false), // false = classes
  convertGradeToDisplayValue: convertGradeToDisplayValue,
  isSmallGroup: false, // Explicit flag - don't rely on function name matching
}

export const dwbCourseFilterConfig = {
  filterFunction: filterDwbGrades,
  sortFunction: sortDwbGradesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, false),
  convertGradeToDisplayValue,
  isSmallGroup: false,
  isDigitalWellBeing: true,
}

// Program mapping configuration
export const courseProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
  isDigitalWellBeing: false,
}

export const dwbCourseProgramConfig = {
  convertGradeNameToLabel,
  getCourseCodeFromGradeLabel: getDwbCourseCodeFromGradeLabel,
  contentGroupCode: 'dwb',
  instructorResponseKey: 'dwb',
  isDigitalWellBeing: true,
}

const createCourseCentricProgramConfig = ({
  contentGroupCode,
  instructorResponseKey,
}) => ({
  convertGradeNameToLabel,
  getCourseCodeFromGradeLabel: gradeLabel =>
    getCoreCourseCodeFromGradeLabel({
      contentGroupCode,
      gradeLabel,
    }),
  contentGroupCode,
  instructorResponseKey,
})

export const k5CourseCentricProgramConfig = createCourseCentricProgramConfig({
  contentGroupCode: 'k5SelDigital',
  instructorResponseKey: 'K5SelDigital',
})

export const mspCourseCentricProgramConfig = createCourseCentricProgramConfig({
  contentGroupCode: 'mspDigital',
  instructorResponseKey: 'MspDigital',
})

// View class behavior configuration
export const courseViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}
